export default __webpack_public_path__ + "static/media/forward.15cf7eb9.svg";